import { gql } from '~/src/generated/portal/gql';

const GET_API_TEST_PLATFORMS = gql(`
  query getApiTestPlatforms {
    apiTestPlatforms {
      platform
    }
  }
`);

export default GET_API_TEST_PLATFORMS;
